import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import "flag-icons/css/flag-icons.min.css";
import { languages } from "./translations";
import { useI18n } from "./I18nContext";

function FlagIcon({ flagCode, className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={`fi fi-${flagCode} block overflow-hidden rounded-[3px] border border-black/10 shadow-sm ${className}`}
      style={{ width: 24, height: 18, backgroundSize: "cover" }}
    />
  );
}

export default function LanguageSelector() {
  const { language, setLanguage } = useI18n();
  const activeLanguage = languages.find((item) => item.code === language) || languages[0];

  return (
    <Menu as="div" className="relative ml-1">
      <MenuButton
        className="flex h-8 w-11 items-center justify-center rounded-full border border-gray-200 bg-white shadow-sm outline-none transition hover:border-gray-300 hover:bg-gray-50 focus:border-neutral-400 focus:ring-2 focus:ring-neutral-100"
        aria-label={`Idioma: ${activeLanguage?.name || language}`}
      >
        <FlagIcon flagCode={activeLanguage.flagCode} />
      </MenuButton>

      <MenuItems
        transition
        className="absolute right-0 z-40 mt-2 w-44 origin-top-right rounded-xl bg-white py-1 shadow-lg ring-1 ring-black/5 transition data-closed:scale-95 data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
      >
        {languages.map((item) => (
          <MenuItem key={item.code}>
            <button
              type="button"
              onClick={() => setLanguage(item.code)}
              className={`flex w-full items-center gap-3 px-3 py-2 text-left text-sm transition hover:bg-gray-50 ${
                language === item.code ? "font-semibold text-neutral-900" : "text-gray-700"
              }`}
            >
              <FlagIcon flagCode={item.flagCode} />
              <span>{item.name}</span>
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
